import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-home-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()"
      xmlns="http://www.w3.org/2000/svg">
      @if (variant() === 'filled') {
        <path
          d="M17.3586 6.67498L11.9003 2.30831C10.8336 1.45831 9.16696 1.44997 8.10863 2.29997L2.65029 6.67498C1.86696 7.29998 1.39196 8.54997 1.55863 9.53331L2.60863 15.8166C2.85029 17.225 4.15863 18.3333 5.58363 18.3333H14.417C15.8253 18.3333 17.1586 17.2 17.4003 15.8083L18.4503 9.52498C18.6003 8.54998 18.1253 7.29998 17.3586 6.67498ZM10.6253 15C10.6253 15.3416 10.342 15.625 10.0003 15.625C9.65863 15.625 9.37529 15.3416 9.37529 15V12.5C9.37529 12.1583 9.65863 11.875 10.0003 11.875C10.342 11.875 10.6253 12.1583 10.6253 12.5V15Z"
          fill="currentColor" />
      } @else {
        <path
          d="M6.01398 1.89336L2.42065 4.69336C1.82065 5.16003 1.33398 6.15336 1.33398 6.90669V11.8467C1.33398 13.3934 2.59398 14.66 4.14065 14.66H11.8607C13.4073 14.66 14.6673 13.3934 14.6673 11.8534V7.00003C14.6673 6.19336 14.1273 5.16003 13.4673 4.70003L9.34732 1.81336C8.41398 1.16003 6.91398 1.19336 6.01398 1.89336Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M8 11.9933V9.99329"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      }
    </svg>
  `,
})
export class HomeIconComponent extends BaseIconComponent {
  override width = input<string>('16');
  override height = input<string>('16');
  override viewBox = input<string>('0 0 16 16');
  variant = input<'outline' | 'filled'>('outline');
}
